import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HexColorPicker } from 'react-colorful';
import './Wizard.css';
import PreviewSite from './PreviewSite';
import { supabase } from './supabaseClient';
import { useAuth } from './AuthContext';
import { appelAPI } from './api';
import RechercheDomaine from './composants/RechercheDomaine';
import { configsEtapeSix } from './configsEtapeSix';
async function uploadImageKit(fichier, tag, nomClient, index) {
  const formData = new FormData();
  formData.append('photo', fichier);
  formData.append('tag', tag);
  formData.append('nomClient', nomClient || 'client-anonyme');
  if (index !== undefined) formData.append('index', index);
  try {
    const { data } = await appelAPI('/api/upload-photo', {
      method: 'POST',
      body: formData,
    });
  
    if (data.succes) return { succes: true, url: data.url };
    return { succes: false, erreur: data.erreur };
  } catch (err) {
    return { succes: false, erreur: 'Erreur réseau : ' + err.message };
  }
}
<SEO {...SEO_PAGES.creerMonSite} />
const secteurs = [
  { id: 'eglise', icon: '⛪', label: 'Église / Ministère' },
  { id: 'restaurant', icon: '🍽️', label: 'Restaurant / Alimentation' },
  { id: 'ong', icon: '🤝', label: 'ONG / Association' },
  { id: 'coach', icon: '🎯', label: 'Coach / Formateur' },
  { id: 'boutique', icon: '🛍️', label: 'Boutique E-commerce' },
  { id: 'ecole', icon: '🎓', label: 'École / Formation' },
  { id: 'salon', icon: '💅', label: 'Salon de Beauté' },
  { id: 'blog', icon: '✍️', label: 'Blog / Média' },
  { id: 'immobilier', icon: '🏠', label: 'Immobilier' },
  { id: 'freelance', icon: '💼', label: 'Freelancer / Portfolio' },
  { id: 'liberal', icon: '⚕️', label: 'Profession Libérale' },
];
const styles_design = [
  { id: 'moderne', label: '✨ Moderne & Épuré', desc: 'Simple, élégant, professionnel' },
  { id: 'colore', label: '🎨 Coloré & Dynamique', desc: 'Vif, énergique, attrayant' },
  { id: 'sobre', label: '💼 Professionnel & Sobre', desc: 'Sérieux, institutionnel, fiable' },
  { id: 'chaleureux', label: '🤗 Chaleureux & Humain', desc: 'Accueillant, proche, familial' },
];
const polices = [
  { id: 'poppins', nom: 'Poppins', style: 'Sans-serif', desc: 'Moderne, chaleureux', recommandePour: ['restaurant', 'boutique', 'coach', 'freelance'] },
  { id: 'inter', nom: 'Inter', style: 'Sans-serif', desc: 'Tech, professionnel', recommandePour: ['freelance', 'liberal'] },
  { id: 'montserrat', nom: 'Montserrat', style: 'Sans-serif', desc: 'Business, élégant', recommandePour: ['boutique', 'immobilier', 'liberal'] },
  { id: 'nunito', nom: 'Nunito', style: 'Sans-serif', desc: 'Chaleureux, amical', recommandePour: ['ong', 'ecole', 'salon'] },
  { id: 'playfair', nom: 'Playfair Display', style: 'Serif', desc: 'Élégance, prestige', recommandePour: ['restaurant', 'immobilier', 'liberal'] },
  { id: 'merriweather', nom: 'Merriweather', style: 'Serif', desc: 'Blog, lisible', recommandePour: ['blog', 'ecole'] },
  { id: 'lora', nom: 'Lora', style: 'Serif', desc: 'Institutionnel', recommandePour: ['eglise', 'ong'] },
  { id: 'bebas', nom: 'Bebas Neue', style: 'Display', desc: 'Impact, percutant', recommandePour: ['immobilier'] },
  { id: 'oswald', nom: 'Oswald', style: 'Display', desc: 'Événementiel', recommandePour: ['freelance'] },
  { id: 'dancing', nom: 'Dancing Script', style: 'Handwritten', desc: 'Festif, artisanal', recommandePour: ['salon'] },
];
const palettesPredefinies = [
  { id: 'pefep', nom: 'PEFEP Corporate', c1: '#005AA9', c2: '#00A651', c3: '#FFFFFF', desc: 'Bleu / Vert PEFEP', recommandePour: ['freelance', 'liberal'] },
  { id: 'elegant', nom: 'Élégance Marine', c1: '#0F172A', c2: '#3B82F6', c3: '#F1F5F9', desc: 'Marine / Bleu clair', recommandePour: ['liberal', 'freelance', 'immobilier'] },
  { id: 'chaleureux', nom: 'Terracotta Warm', c1: '#7C2D12', c2: '#F97316', c3: '#FFF7ED', desc: 'Terre / Orange chaud', recommandePour: ['restaurant', 'salon'] },
  { id: 'frais', nom: 'Menthe Fraîche', c1: '#065F46', c2: '#10B981', c3: '#ECFDF5', desc: 'Vert forêt / Menthe', recommandePour: ['ong', 'ecole', 'coach'] },
  { id: 'royal', nom: 'Royal Purple', c1: '#4C1D95', c2: '#A855F7', c3: '#FAF5FF', desc: 'Violet royal / Lavande', recommandePour: ['salon', 'boutique'] },
  { id: 'spirituel', nom: 'Sérénité', c1: '#1E3A8A', c2: '#F59E0B', c3: '#FFFBEB', desc: 'Bleu nuit / Or doux', recommandePour: ['eglise', 'ong'] },
  { id: 'moderne', nom: 'Slate Moderne', c1: '#1E293B', c2: '#0EA5E9', c3: '#F8FAFC', desc: 'Ardoise / Cyan', recommandePour: ['freelance', 'liberal', 'immobilier'] },
  { id: 'vibrant', nom: 'Rouge Vibrant', c1: '#7F1D1D', c2: '#DC2626', c3: '#FEF2F2', desc: 'Bordeaux / Rouge vif', recommandePour: ['restaurant', 'boutique'] },
];
const reseauxList = [
  { id: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/votrepagefacebook' },
  { id: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/votrecompte' },
  { id: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/company/votreentreprise' },
  { id: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@votrechaine' },
  { id: 'tiktok', label: 'TikTok', placeholder: 'https://tiktok.com/@votrecompte' },
];
const objectifsOptions = [
  'Être trouvé sur Internet',
  'Vendre mes produits/services',
  'Partager des informations',
  'Recruter des membres / bénévoles',
  'Attirer des donateurs',
  'Promouvoir mon expertise',
  'Autre',
];
const moyensPaiement = [
  { id: 'moncash', label: 'MonCash', champ: 'Numéro MonCash', placeholder: '+509 3700 0000' },
  { id: 'natcash', label: 'NatCash', champ: 'Numéro NatCash', placeholder: '+509 3800 0000' },
  { id: 'paypal', label: 'PayPal', champ: 'Email PayPal', placeholder: 'paiement@monorganisation.com' },
  { id: 'virement_bancaire', label: 'Virement Bancaire', virementDetaille: true },
  { id: 'especes', label: 'Espèces', champ: 'Instructions', placeholder: 'Ex: Paiement à notre bureau' },
];
const ctaOptions = ['Nous appeler', 'Réserver', "S'inscrire", 'Faire un don', 'Acheter', 'Nous contacter', 'En savoir plus'];

const questionsSecteur = {
  eglise: [{ id: 'denomination', label: 'Dénomination', type: 'text', placeholder: 'Ex: Catholique' }, { id: 'evenements', label: 'Événements', type: 'textarea', placeholder: 'Ex: Campagne...' }, { id: 'message_accueil', label: "Message d'accueil", type: 'textarea', placeholder: 'Ex: Bienvenue !' }],
  restaurant: [{ id: 'type_cuisine', label: 'Type cuisine', type: 'text', placeholder: 'Ex: Haïtienne' }, { id: 'horaires_resto', label: "Horaires", type: 'text', placeholder: 'Ex: 8h-22h' }, { id: 'promo_resto', label: 'Promotion', type: 'textarea', placeholder: 'Ex: Menu du jour...' }],
  ong: [{ id: 'cause', label: 'Cause', type: 'textarea', placeholder: "Ex: Éducation..." }, { id: 'benevoles', label: 'Bénévoles ?', type: 'choix', options: ['Oui', 'Non'] }, { id: 'realisations', label: 'Réalisations', type: 'textarea', placeholder: "Ex: 500 enfants..." }],
  coach: [{ id: 'domaine_coach', label: "Domaine", type: 'text', placeholder: 'Ex: Leadership' }, { id: 'accroche_coach', label: 'Signature', type: 'text', placeholder: "J'aide..." }, { id: 'lien_calendrier', label: 'Calendrier', type: 'text', placeholder: 'calendly.com/...' }],
  boutique: [{ id: 'livraison_boutique', label: 'Livraison ?', type: 'choix', options: ['Oui — locale', 'Oui — nationale', 'Non'] }, { id: 'zones_livraison', label: 'Zones', type: 'text', placeholder: 'Ex: Léogâne...' }, { id: 'commande_boutique', label: 'Comment commander ?', type: 'choix', options: ['Via WhatsApp', 'Formulaire', 'En magasin'] }],
  ecole: [{ id: 'audience_ecole', label: "Pour qui ?", type: 'text', placeholder: 'Ex: Enfants...' }, { id: 'inscription', label: "Prochaine session", type: 'text', placeholder: 'Ex: Septembre 2026' }, { id: 'admission', label: "Admission", type: 'textarea', placeholder: "Ex: Test..." }],
  salon: [{ id: 'horaires_salon', label: "Horaires", type: 'text', placeholder: 'Ex: 8h-19h' }, { id: 'produits_salon', label: 'Produits ?', type: 'choix', options: ['Oui', 'Non'] }, { id: 'fidelite', label: 'Forfaits ?', type: 'textarea', placeholder: 'Ex: Forfait mensuel...' }],
  blog: [{ id: 'sujet_blog', label: 'Sujet', type: 'text', placeholder: 'Ex: Actualités...' }, { id: 'audience_blog', label: 'Public', type: 'text', placeholder: 'Ex: Entrepreneurs...' }, { id: 'langue_blog', label: 'Langue', type: 'choix', options: ['Français', 'Créole', 'Anglais', 'Bilingue'] }],
  immobilier: [{ id: 'type_agent', label: "Type", type: 'choix', options: ['Agent', 'Agence', 'Promoteur'] }, { id: 'zones_immo', label: "Zones", type: 'text', placeholder: 'Ex: Pétion-Ville...' }, { id: 'services_immo', label: 'Services', type: 'choix', options: ['Gestion locative', 'Conseil juridique', 'Estimation', 'Aucun'] }],
  freelance: [{ id: 'metier', label: "Métier", type: 'text', placeholder: 'Ex: Graphiste' }, { id: 'clients_type', label: 'Clients', type: 'choix', options: ['Entreprises', 'ONG', 'Particuliers', 'Médias'] }, { id: 'disponibilite', label: 'Disponibilité', type: 'choix', options: ['100% distance', 'Local et distance', 'Local uniquement'] }],
  liberal: [{ id: 'profession', label: 'Profession', type: 'text', placeholder: 'Ex: Médecin' }, { id: 'specialisation', label: 'Spécialisation', type: 'text', placeholder: 'Ex: Droit affaires' }, { id: 'experience', label: "Expérience", type: 'text', placeholder: "Ex: 15 ans" }],
};
function UploadPhotoV5({ label, tag, nomClient, index, urlUploadee, onUpload, optional = true }) {
  const [uploading, setUploading] = useState(false);
  const [erreur, setErreur] = useState('');
  const handleFichier = async (e) => {
    const fichier = e.target.files[0];
    if (!fichier) return;
    setUploading(true);
    setErreur('');
    const result = await uploadImageKit(fichier, tag, nomClient, index);
    setUploading(false);
    if (result.succes) {
      onUpload(result.url);
    } else {
      setErreur(result.erreur || 'Erreur lors de l\'upload');
    }
  };
  return (
    <div className="form-group full-width">
      <label>{label} {optional && <span className="optional">(optionnel)</span>}</label>
      <div className="upload-photo-v5">
        <input type="file" accept="image/*" onChange={handleFichier} className="file-input" disabled={uploading} />
        {uploading && (
          <div className="upload-spinner">
            <span className="spinner"></span>
            <span>Upload en cours vers ImageKit...</span>
          </div>
        )}
        {urlUploadee && !uploading && (
          <div className="upload-preview">
            <img src={urlUploadee} alt="Aperçu" className="upload-miniature" />
            <div className="upload-preview-info">
              <span className="upload-ok">✅ Photo uploadée avec succès</span>
              <a href={urlUploadee} target="_blank" rel="noopener noreferrer" className="upload-url">Voir en grand</a>
            </div>
          </div>
        )}
        {erreur && <div className="upload-erreur">⚠️ {erreur}</div>}
      </div>
    </div>
  );
}
function SelecteurCouleur({ label, valeur, onChange, ouvert, setOuvert }) {
  return (
    <div className="couleur-item-enrichi">
      <label>{label}</label>
      <div className="couleur-preview-bloc">
        <div className="couleur-swatch" style={{ background: valeur }} onClick={() => setOuvert(!ouvert)}>
          <span className="couleur-swatch-hex" style={{ color: estFonce(valeur) ? '#fff' : '#000' }}>{valeur.toUpperCase()}</span>
        </div>
        <input type="text" className="couleur-hex-input" value={valeur} onChange={e => {
          const val = e.target.value;
          if (/^#[0-9A-Fa-f]{0,6}$/.test(val)) onChange(val);
        }} placeholder="#005AA9" maxLength={7} />
      </div>
      {ouvert && <div className="couleur-picker-wrapper"><HexColorPicker color={valeur} onChange={onChange} /></div>}
    </div>
  );
}
function estFonce(hex) {
  const clean = (hex || '').replace('#', '');
  if (clean.length !== 6) return false;
  const r = parseInt(clean.substr(0, 2), 16), g = parseInt(clean.substr(2, 2), 16), b = parseInt(clean.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) < 140;
}
function estCouleurChaude(hex) {
  const clean = (hex || '').replace('#', '');
  if (clean.length !== 6) return false;
  const r = parseInt(clean.substr(0, 2), 16), g = parseInt(clean.substr(2, 2), 16), b = parseInt(clean.substr(4, 2), 16);
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  if (max === min) return false;
  let h;
  const d = max - min;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
  else if (max === g) h = ((b - r) / d + 2) * 60;
  else h = ((r - g) / d + 4) * 60;
  return h < 60 || h > 300;
}
function PalettePreview({ palette, isActive, onClick, recommande }) {
  return (
    <button type="button" className={`palette-card ${isActive ? 'selected' : ''}`} onClick={onClick}>
      {recommande && <span className="palette-badge">✨ Recommandé</span>}
      <div className="palette-visuel">
        <div className="palette-couleur" style={{ background: palette.c1 }}></div>
        <div className="palette-couleur" style={{ background: palette.c2 }}></div>
        <div className="palette-couleur" style={{ background: palette.c3, border: '1px solid #e5e7eb' }}></div>
      </div>
      <div className="palette-nom">{palette.nom}</div>
      <div className="palette-desc">{palette.desc}</div>
    </button>
  );
}
function ApercuTempsReel({ couleur1, couleur2, couleur3, police }) {
  const policeConfig = polices.find(p => p.id === police);
  const fontFamily = policeConfig ? policeConfig.nom : 'Poppins';
  return (
    <div className="apercu-temps-reel">
      <div className="apercu-titre-label">🎨 Aperçu temps réel</div>
      <div className="apercu-mockup" style={{ fontFamily: `'${fontFamily}', sans-serif` }}>
        <div className="apercu-navbar" style={{ background: couleur1 }}>
          <span style={{ color: estFonce(couleur1) ? '#fff' : '#000', fontWeight: 700 }}>Mon Site</span>
        </div>
        <div className="apercu-hero" style={{ background: `linear-gradient(135deg, ${couleur1} 0%, ${couleur2} 100%)` }}>
          <div style={{ color: '#fff', fontWeight: 700, fontSize: 18, marginBottom: 8 }}>Titre principal</div>
          <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: 12, marginBottom: 12 }}>Un sous-titre</div>
          <button className="apercu-btn" style={{ background: estCouleurChaude(couleur1) ? '#fff' : couleur2, color: estCouleurChaude(couleur1) ? couleur1 : '#fff' }}>Bouton</button>
        </div>
        <div className="apercu-contenu">
          <div style={{ color: couleur1, fontWeight: 700, fontSize: 14, marginBottom: 6 }}>Section titre</div>
          <div style={{ color: '#555', fontSize: 11 }}>Texte de contenu...</div>
        </div>
      </div>
    </div>
  );
}
function BlocConseils({ titre, conseils }) {
  if (!conseils || conseils.length === 0) return null;
  return (
    <div className="bloc-conseils">
      <div className="bloc-conseils-titre">💡 {titre || 'Nos conseils'}</div>
      <ul>{conseils.map((c, i) => <li key={i}>{c}</li>)}</ul>
    </div>
  );
}
function ModaleExemple({ exemple, ouverte, fermer, titreSecteur }) {
  if (!ouverte) return null;
  return (
    <div className="modale-overlay" onClick={fermer}>
      <div className="modale-contenu" onClick={e => e.stopPropagation()}>
        <div className="modale-header">
          <h3>👁️ Exemple — {titreSecteur}</h3>
          <button type="button" className="modale-fermer" onClick={fermer}>✕</button>
        </div>
        <div className="modale-body">
          <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>Exemple pour vous inspirer.</p>
          <div className="modale-exemple">
            {Object.entries(exemple).map(([cle, val]) => (
              <div key={cle} className="modale-exemple-item">
                <span className="modale-exemple-cle">{cle.replace(/_/g, ' ')} :</span>
                <span className="modale-exemple-val">{Array.isArray(val) ? val.join(', ') : val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
function renderChamp(champ, item, updateChamp, nomClient, index) {
  const val = item[champ.id];
  if (champ.type === 'text') return <input type="text" placeholder={champ.placeholder} value={val || ''} onChange={e => updateChamp(champ.id, e.target.value)} />;
  if (champ.type === 'textarea') return <textarea className="form-textarea" rows={3} placeholder={champ.placeholder} value={val || ''} onChange={e => updateChamp(champ.id, e.target.value)} />;
  if (champ.type === 'choix') return (
    <div className="choix-groupe">
      {champ.options.map(opt => (
        <button key={opt} type="button" className={`choix-btn ${val === opt ? 'selected' : ''}`} onClick={() => updateChamp(champ.id, opt)}>
          {val === opt ? '✅ ' : ''}{opt}
        </button>
      ))}
    </div>
  );
  if (champ.type === 'multi') {
    const selected = Array.isArray(val) ? val : [];
    const toggleOption = (opt) => {
      const nouveau = selected.includes(opt) ? selected.filter(o => o !== opt) : [...selected, opt];
      updateChamp(champ.id, nouveau);
    };
    return (
      <div className="choix-groupe">
        {champ.options.map(opt => (
          <button key={opt} type="button" className={`choix-btn ${selected.includes(opt) ? 'selected' : ''}`} onClick={() => toggleOption(opt)}>
            {selected.includes(opt) ? '✅ ' : ''}{opt}
          </button>
        ))}
      </div>
    );
  }
  if (champ.type === 'photo') {
    return (
      <UploadPhotoV5 label={champ.label} tag="item" nomClient={nomClient} index={index} urlUploadee={val} onUpload={(url) => updateChamp(champ.id, url)} />
    );
  }
  return null;
}
function FormulaireItem({ index, item, champs, onChange, onDelete, canDelete, labelItem, nomClient }) {
  const updateChamp = (id, valeur) => onChange(index, id, valeur);
  const champsAffiches = champs.filter(c => {
    if (!c.conditionalOn) return true;
    return c.conditionalOn.values.includes(item[c.conditionalOn.field]);
  });
  const secteurLabelClean = labelItem.charAt(0).toUpperCase() + labelItem.slice(1);
  return (
    <div className="service-block">
      <div className="service-header">
        <span>{secteurLabelClean} #{index + 1}</span>
        {canDelete && <button type="button" className="btn-supprimer-item" onClick={() => onDelete(index)}>🗑️ Supprimer</button>}
      </div>
      <div className="form-grid">
        {champsAffiches.map(champ => (
          <div key={champ.id} className={`form-group ${(champ.type !== 'text' && champ.type !== 'photo') ? 'full-width' : ''} ${champ.type === 'photo' ? 'full-width' : ''}`}>
            {champ.type !== 'photo' && <label>{champ.label} {champ.optional && <span className="optional">(optionnel)</span>}</label>}
            {renderChamp(champ, item, updateChamp, nomClient, index)}
          </div>
        ))}
      </div>
    </div>
  );
}
function EtapeSix({ secteurChoisi, items, setItems, modeGlobalValue, setModeGlobalValue, typeEcole, setTypeEcole, nomClient }) {
  const [modaleOuverte, setModaleOuverte] = useState(false);
  if (!secteurChoisi) return null;
  const config = configsEtapeSix[secteurChoisi];
  if (!config) return null;
  let champs = config.champs;
  if (secteurChoisi === 'ecole') {
    if (typeEcole === 'Enseignement supérieur') champs = config.champsSuperieur;
    else if (typeEcole) champs = config.champsClassique;
    else champs = [];
  }
  const nbItems = items.length;
  const canDelete = nbItems > config.minItems;
  const peutAjouter = nbItems < config.maxItems;
  const updateItem = (index, champId, valeur) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [champId]: valeur };
    setItems(newItems);
  };
  const ajouterItem = () => { if (nbItems < config.maxItems) setItems([...items, {}]); };
  const supprimerItem = (index) => { if (nbItems > config.minItems) setItems(items.filter((_, i) => i !== index)); };
  return (
    <div>
      <h2>{config.icone} {config.titre}</h2>
      <p>{config.intro}</p>
      <BlocConseils conseils={config.conseils} />
      {config.notePedagogique && <div className="note-pedagogique">{config.notePedagogique}</div>}
      {config.infoSupp && <div className="info-supp">📌 {config.infoSupp}</div>}
      {config.modeGlobal && (
        <div className="mode-global-block">
          <label>{config.modeGlobal.label}</label>
          {config.modeGlobal.info && <p className="mode-global-info">{config.modeGlobal.info}</p>}
          <div className="choix-groupe">
            {config.modeGlobal.options.map(opt => {
              const currentVal = secteurChoisi === 'ecole' ? typeEcole : modeGlobalValue;
              const isSelected = currentVal === opt;
              return (
                <button key={opt} type="button" className={`choix-btn ${isSelected ? 'selected' : ''}`}
                  onClick={() => { if (secteurChoisi === 'ecole') setTypeEcole(opt); else setModeGlobalValue(opt); }}>
                  {isSelected ? '✅ ' : ''}{opt}
                </button>
              );
            })}
          </div>
        </div>
      )}
      {config.exemple && champs.length > 0 && (
        <div className="bouton-exemple-wrapper">
          <button type="button" className="btn-voir-exemple" onClick={() => setModaleOuverte(true)}>👁️ Voir un exemple</button>
        </div>
      )}
      {champs.length > 0 && (
        <div className="compteur-items">
          <strong>{nbItems}</strong> sur {config.minItems} min • {config.maxItems} max
          {nbItems < config.minItems && <span className="compteur-manque">— encore {config.minItems - nbItems}</span>}
        </div>
      )}
      {champs.length > 0 && items.map((item, i) => (
        <FormulaireItem key={i} index={i} item={item} champs={champs} onChange={updateItem} onDelete={supprimerItem} canDelete={canDelete} labelItem={config.labelItem} nomClient={nomClient} />
      ))}
      {champs.length > 0 && (
        <button type="button" className="btn-ajouter" onClick={ajouterItem} disabled={!peutAjouter}>
          {peutAjouter ? `+ Ajouter un(e) ${config.labelItem}` : `Maximum atteint (${config.maxItems})`}
        </button>
      )}
      {champs.length === 0 && secteurChoisi === 'ecole' && (
        <div className="info-supp" style={{ marginTop: 20 }}>👆 Choisissez d'abord le type d'établissement.</div>
      )}
      <ModaleExemple exemple={config.exemple} ouverte={modaleOuverte} fermer={() => setModaleOuverte(false)} titreSecteur={config.titre} />
    </div>
  );
}
function VirementBancaireForm({ virement, setVirement }) {
  const updateChamp = (champ, val) => setVirement({ ...virement, [champ]: val });
  return (
    <div className="virement-bancaire-block">
      <div className="virement-note">⚠️ <strong>Assurez-vous d'avoir accès à ce compte en ligne</strong> pour vérification.</div>
      <div className="form-grid">
        <div className="form-group"><label>Titulaire *</label><input type="text" placeholder="Ex: Isaac PRESMY" value={virement.titulaire || ''} onChange={e => updateChamp('titulaire', e.target.value)} /></div>
        <div className="form-group"><label>Numéro *</label><input type="text" placeholder="Ex: 1234567890" value={virement.numero || ''} onChange={e => updateChamp('numero', e.target.value)} /></div>
        <div className="form-group"><label>Banque *</label><input type="text" placeholder="Ex: Sogebank" value={virement.banque || ''} onChange={e => updateChamp('banque', e.target.value)} /></div>
        <div className="form-group"><label>Monnaie *</label>
          <div className="choix-groupe">
            {['Gourdes (HTG)', 'Dollars (USD)'].map(opt => (
              <button key={opt} type="button" className={`choix-btn ${virement.monnaie === opt ? 'selected' : ''}`} onClick={() => updateChamp('monnaie', opt)}>
                {virement.monnaie === opt ? '✅ ' : ''}{opt}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
function TemoignageForm({ index, temoignage, onChange, nomClient }) {
  return (
    <div className="service-block">
      <div className="service-header">Témoignage #{index + 1}</div>
      <div className="form-grid">
        <div className="form-group"><label>Nom du client</label>
          <input type="text" placeholder="Ex: Marie Dupont" value={temoignage.nom || ''} onChange={e => onChange('nom', e.target.value)} />
        </div>
        <div className="form-group"><label>Ville / Organisation</label>
          <input type="text" placeholder="Ex: Port-au-Prince" value={temoignage.ville || ''} onChange={e => onChange('ville', e.target.value)} />
        </div>
        <div className="form-group full-width"><label>Témoignage</label>
          <textarea className="form-textarea" rows={3} placeholder="Ex: Grâce à..." value={temoignage.texte || ''} onChange={e => onChange('texte', e.target.value)} />
        </div>
        <UploadPhotoV5 label="Photo du client" tag="temoignage" nomClient={nomClient} index={index} urlUploadee={temoignage.photo_url} onUpload={(url) => onChange('photo_url', url)} />
      </div>
    </div>
  );
}
function QuestionsSecteur({ secteurId, reponses, onChange }) {
  const questions = questionsSecteur[secteurId] || [];
  return (
    <div className="form-grid">
      {questions.map(q => (
        <div key={q.id} className={`form-group ${q.type !== 'text' ? 'full-width' : ''}`}>
          <label>{q.label}</label>
          {q.type === 'text' && <input type="text" placeholder={q.placeholder} value={reponses[q.id] || ''} onChange={e => onChange(q.id, e.target.value)} />}
          {q.type === 'textarea' && <textarea className="form-textarea" rows={3} placeholder={q.placeholder} value={reponses[q.id] || ''} onChange={e => onChange(q.id, e.target.value)} />}
          {q.type === 'choix' && (
            <div className="choix-groupe">
              {q.options.map(opt => (
                <button key={opt} type="button" className={`choix-btn ${reponses[q.id] === opt ? 'selected' : ''}`} onClick={() => onChange(q.id, opt)}>
                  {reponses[q.id] === opt ? '✅ ' : ''}{opt}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
function PageClient() {
  const navigate = useNavigate();
  const { user } = useAuth(); // ⭐ v3.0 — Récupère l'utilisateur connecté

  // ══ v6.0 — VÉRIFICATION DU QUOTA À L'ENTRÉE DU WIZARD ══
  // Bloque AVANT le premier upload : ni stockage ni tokens gaspillés
  const [quotaVerifie, setQuotaVerifie] = useState(false);
  const [quotaBloque, setQuotaBloque] = useState(null);
  const [etape, setEtape] = useState(1);
  const [secteurChoisi, setSecteurChoisi] = useState(null);
  const [infos, setInfos] = useState({ nom: '', ville: '', email: '', whatsapp: '', adresse: '' });
  const [objectifs, setObjectifs] = useState([]);
  const [publicCible, setPublicCible] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [reseauxChoisis, setReseauxChoisis] = useState({});
  const [couleur1, setCouleur1] = useState('#005AA9');
  const [couleur2, setCouleur2] = useState('#00A651');
  const [couleur3, setCouleur3] = useState('#FFFFFF');
  const [picker1Ouvert, setPicker1Ouvert] = useState(false);
  const [picker2Ouvert, setPicker2Ouvert] = useState(false);
  const [picker3Ouvert, setPicker3Ouvert] = useState(false);
  const [paletteChoisie, setPaletteChoisie] = useState(null);
  const [styleDesign, setStyleDesign] = useState(null);
  const [police, setPolice] = useState(null);
  const [heroDescription, setHeroDescription] = useState('');
  const [heroResultat, setHeroResultat] = useState('');
  const [heroCta, setHeroCta] = useState(null);
  const [heroPhotoUrl, setHeroPhotoUrl] = useState('');
  const [aproposResume, setAproposResume] = useState('');
  const [anneeCreation, setAnneeCreation] = useState('');
  const [chiffres, setChiffres] = useState('');
  const [temoignages, setTemoignages] = useState([{ nom: '', ville: '', texte: '', photo_url: '' }]);
  const [messageInvitation, setMessageInvitation] = useState('');
  const [histoire, setHistoire] = useState({ debut: '', defi: '', aujourdhui: '' });
  const [mission, setMission] = useState('');
  const [vision, setVision] = useState('');
  const [valeurs, setValeurs] = useState('');
  const [equipe, setEquipe] = useState(null);
  const [membres, setMembres] = useState([{ nom: '', poste: '', description: '', photo_url: '' }]);
  const [raisonChoisir, setRaisonChoisir] = useState('');
  const [difference, setDifference] = useState('');
  const [items, setItems] = useState([]);
  const [modeGlobalValue, setModeGlobalValue] = useState('');
  const [typeEcole, setTypeEcole] = useState('');
  const [titreContact, setTitreContact] = useState('');
  const [modesContact, setModesContact] = useState({});
  const [champsForm, setChampsForm] = useState({});
  const [messageBienvenue, setMessageBienvenue] = useState('');
  const [googleMaps, setGoogleMaps] = useState('');
  const [horaires, setHoraires] = useState('');
  const [moyensDons, setMoyensDons] = useState({});
  const [virementBancaire, setVirementBancaire] = useState({ titulaire: '', numero: '', banque: '', monnaie: '' });
  const [motsClesSEO, setMotsClesSEO] = useState('');
  const [reponsesSecteur, setReponsesSecteur] = useState({});
  const [generationEnCours, setGenerationEnCours] = useState(false);
  const [siteGenere, setSiteGenere] = useState(null);
  const [siteIdEnBase, setSiteIdEnBase] = useState(null);
  const [erreurGeneration, setErreurGeneration] = useState('');
  const [apercuHtml, setApercuHtml] = useState('');
  const secteurLabel = secteurs.find(s => s.id === secteurChoisi)?.label;
  const infosCompletes = infos.nom && infos.ville && infos.email && objectifs.length > 0;
  const designComplet = styleDesign && police;
  const configEtape6 = secteurChoisi ? configsEtapeSix[secteurChoisi] : null;
  const etape6Complete = (() => {
    if (!configEtape6) return false;
    if (items.length < configEtape6.minItems) return false;
    if (secteurChoisi === 'restaurant' && !modeGlobalValue) return false;
    if (secteurChoisi === 'ecole' && !typeEcole) return false;
    return true;
  })();
  const appliquerPalette = (palette) => {
    setCouleur1(palette.c1); setCouleur2(palette.c2); setCouleur3(palette.c3);
    setPaletteChoisie(palette.id);
  };
  const polices_triees = () => {
    if (!secteurChoisi) return polices;
    const recommandees = polices.filter(p => p.recommandePour.includes(secteurChoisi));
    const autres = polices.filter(p => !p.recommandePour.includes(secteurChoisi));
    return [...recommandees, ...autres];
  };
  const palettes_triees = () => {
    if (!secteurChoisi) return palettesPredefinies;
    const recommandees = palettesPredefinies.filter(p => p.recommandePour.includes(secteurChoisi));
    const autres = palettesPredefinies.filter(p => !p.recommandePour.includes(secteurChoisi));
    return [...recommandees, ...autres];
  };
  const handleChoixSecteur = (id) => {
    if (secteurChoisi !== id) { setItems([]); setModeGlobalValue(''); setTypeEcole(''); }
    setSecteurChoisi(id);
  };
  const toggleObjectif = (opt) => {
    if (objectifs.includes(opt)) setObjectifs(objectifs.filter(o => o !== opt));
    else if (objectifs.length < 3) setObjectifs([...objectifs, opt]);
  };
  const toggleReseau = (id) => { const u = { ...reseauxChoisis }; if (u[id] !== undefined) delete u[id]; else u[id] = ''; setReseauxChoisis(u); };
  const toggleMoyenDon = (id) => { const u = { ...moyensDons }; if (u[id] !== undefined) delete u[id]; else u[id] = ''; setMoyensDons(u); };
  const toggleModeContact = (id) => { const u = { ...modesContact }; if (u[id]) delete u[id]; else u[id] = true; setModesContact(u); };
  const toggleChampForm = (champ) => { const u = { ...champsForm }; if (u[champ]) delete u[champ]; else u[champ] = true; setChampsForm(u); };
  const updateTemoignage = (index, champ, valeur) => { const t = [...temoignages]; t[index] = { ...t[index], [champ]: valeur }; setTemoignages(t); };
  const updateMembre = (index, champ, valeur) => { const m = [...membres]; m[index] = { ...m[index], [champ]: valeur }; setMembres(m); };
  // ══════════════════════════════════════════════════════════════
  // ⭐ SAUVEGARDE SUPABASE v3.0 — Enregistre le site en BDD
  // ══════════════════════════════════════════════════════════════
  const sauvegarderSite = async (contenuGenere) => {
    if (!user?.id) {
      console.warn('⚠️ Utilisateur non connecté — sauvegarde ignorée');
      return { succes: false, raison: 'non_connecte' };
    }
    try {
      const { data, error } = await supabase
        .from('sites_generes')
        .insert([
          {
            client_id: user.id,
            nom_organisation: infos.nom || 'Site sans nom',
            secteur: secteurChoisi,
            ville: infos.ville || null,
            contenu_json: contenuGenere,
            design_json: {
              style: styleDesign,
              police: police,
              couleur1: couleur1,
              couleur2: couleur2,
              couleur3: couleur3,
              paletteChoisie: paletteChoisie,
            },
            photos_json: {
              logo: logoUrl || null,
              hero: heroPhotoUrl || null,
              nb_items_avec_photo: items.filter(i => i.photo || i.photo_url).length,
              nb_temoignages_avec_photo: temoignages.filter(t => t.photo_url).length,
              nb_membres_avec_photo: membres.filter(m => m.photo_url).length,
            },
            statut: 'brouillon',
          },
        ])
        .select();
      if (error) {
        console.error('❌ Erreur sauvegarde site :', error);
        return { succes: false, raison: 'erreur_bdd', message: error.message };
      }
      console.log('✅ Site sauvegardé en BDD — ID :', data[0].id);
      return { succes: true, siteId: data[0].id };
    } catch (err) {
      console.error('❌ Exception sauvegarde :', err);
      return { succes: false, raison: 'exception', message: err.message };
    }
  };
  // ══ GÉNÉRATION SITE v5.2 — ENVOIE MEMBRES + RÉSEAUX + ÉQUIPE ══
  const genererSite = async () => {
    setGenerationEnCours(true);
    setErreurGeneration('');
    try {
    const paiements = moyensPaiement
        .filter(opt => moyensDons[opt.id] !== undefined)
        .map(opt => {
          if (opt.id === 'virement_bancaire') {
            const v = virementBancaire || {};
            const det = v.banque
              ? `${v.banque} — ${v.titulaire || ''} — ${v.numero || ''}${v.monnaie ? ' (' + v.monnaie + ')' : ''}`
              : 'Détails communiqués après la commande';
            return { id: 'virement_bancaire', label: 'Virement bancaire', details: det };
          }
          return { id: opt.id, label: opt.label, details: moyensDons[opt.id] || '' };
        });  
      const { data } = await appelAPI('/api/generer-site', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          secteur: secteurChoisi,
          infos: { nom: infos.nom, ville: infos.ville, email: infos.email, whatsapp: infos.whatsapp, adresse: infos.adresse, objectifs, publicCible },
          design: { style: styleDesign, police, couleur1, couleur2, couleur3 },
          pages: { heroDescription, heroResultat, heroCta, aproposResume, anneeCreation, chiffres, mission, vision, valeurs, raisonChoisir, difference },
          items,
          modeGlobal: modeGlobalValue,
          typeEcole,
          motsClesSEO,
          reponsesSecteur,
          temoignages,
          reseauxSociaux: reseauxChoisis,   // ⭐ v5.2 - Réseaux sociaux
          membres,                            // ⭐ v5.2 - Membres équipe
          equipe,                             // ⭐ v5.2 - Choix équipe (Oui/Non/Seul)
          moyensPaiement: paiements,
          photos: {
            logo: logoUrl,
            hero: heroPhotoUrl,
          },
        })
      });
      if (data.succes) {
        setApercuHtml(data.apercuHtml || '');
        // ── Normalisation : accepte objet OU chaîne (compatibilité) ──
        let contenuPropre = data.contenu;
        if (typeof contenuPropre === 'string') {
          try {
            contenuPropre = JSON.parse(
              contenuPropre
                .replace(/^```json\s*/i, '')
                .replace(/^```\s*/, '')
                .replace(/```\s*$/, '')
                .trim()
            );
          } catch (e) {
            setErreurGeneration('Le contenu généré est illisible. Veuillez réessayer.');
            setGenerationEnCours(false);
            return;
          }
        }
        // ⭐ v3.0 — Sauvegarder le site en BDD Supabase
        const resultSauvegarde = await sauvegarderSite(contenuPropre);
        if (resultSauvegarde.succes && resultSauvegarde.siteId) {
          // On retient l'identifiant : il sert de reference de paiement.
          setSiteIdEnBase(resultSauvegarde.siteId);
        } else if (resultSauvegarde.raison !== 'non_connecte') {
          console.warn('⚠️ Site généré mais non sauvegardé en BDD :', resultSauvegarde.message);
        }
        setSiteGenere(contenuPropre);
        setEtape(10);
      } else {
        setErreurGeneration(data.erreur || 'Erreur lors de la génération.');
      }
    } catch (err) {
      setErreurGeneration('Impossible de contacter le serveur.');
    }
    setGenerationEnCours(false);
  };
  // ══ v6.0 — Contrôle du quota au chargement ══
  useEffect(() => {
    let annule = false;

    const verifier = async () => {
      if (!user?.id) { setQuotaVerifie(true); return; }
      try {
        const { ok, data } = await appelAPI('/api/mon-quota');
        if (annule) return;

        if (ok && data.succes && data.quota && !data.quota.illimite) {
          const q = data.quota;
          if (q.restant !== undefined && q.restant <= 0) {
            setQuotaBloque({
              limite: q.limite,
              utilise: q.utilise,
              estDev: data.utilisateur?.type_compte === 'dev',
            });
          }
        }
      } catch (err) {
        // En cas d'indisponibilité, on laisse passer :
        // le backend refusera de toute façon à la génération
        console.warn('Quota indisponible :', err.message);
      } finally {
        if (!annule) setQuotaVerifie(true);
      }
    };

    verifier();
    return () => { annule = true; };
  }, [user]);

  // ── Écran d'attente pendant la vérification ──
  if (!quotaVerifie) {
    return (
      <div className="wizard-container">
        <div className="wizard-verification">
          <div className="wizard-spinner" />
          <p>Vérification de votre espace...</p>
        </div>
      </div>
    );
  }

  // ── Écran de blocage si le quota est atteint ──
  if (quotaBloque) {
    return (
      <div className="wizard-container">
        <div className="wizard-bloque">
          <div className="wizard-bloque-icone">🔒</div>
          <h2>Votre site précédent n'est pas encore réglé</h2>

          <p className="wizard-bloque-compteur">
            {quotaBloque.utilise} site{quotaBloque.utilise > 1 ? 's' : ''} en attente
            {' '}sur {quotaBloque.limite} autorisé{quotaBloque.limite > 1 ? 's' : ''}
          </p>

          <p className="wizard-bloque-texte">
            {quotaBloque.estDev
              ? "Réglez un projet en attente ou passez à un forfait supérieur pour continuer à générer des sites."
              : "Finalisez le règlement de votre site actuel et vous pourrez en créer un nouveau immédiatement."}
          </p>

          <div className="wizard-bloque-actions">
            <button
              type="button"
              className="btn-next"
              onClick={() => navigate('/tableau-de-bord')}
            >
              💳 Aller à mon tableau de bord
            </button>

            <a
              className="btn-back"
              href="https://wa.me/50947376200?text=Bonjour%20PEFEP%20Tech%2C%20j%27ai%20une%20question%20sur%20mon%20site%20en%20attente."
              target="_blank"
              rel="noopener noreferrer"
            >
              💬 Contacter le support
            </a>
          </div>
        </div>
      </div>
    );
  }

  const Badge = () => <div className="etape-badge">✅ {secteurLabel}</div>;
  return (
    <div className="wizard-container">
      <div className="progress-bar">
        {['Type de site', 'Infos de base', 'Design', 'Page Accueil', 'À Propos', 'Contenu principal', 'Contact', 'Finalisation'].map((label, i) => (
          <div key={i} className={`progress-step ${etape >= i + 1 ? 'active' : ''}`}>{i + 1}. {label}</div>
        ))}
      </div>
      {etape === 1 && (
        <div className="wizard-content">
          <h2>Quel type de site souhaitez-vous créer ?</h2>
          <p>Choisissez votre secteur.</p>
          <div className="secteurs-grid">
            {secteurs.map(s => (
              <button key={s.id} type="button" className={`secteur-card ${secteurChoisi === s.id ? 'selected' : ''}`} onClick={() => handleChoixSecteur(s.id)}>
                <span className="secteur-icon">{s.icon}</span>
                <span className="secteur-label">{s.label}</span>
              </button>
            ))}
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => navigate('/')}>← Retour</button>
            <button type="button" className={`btn-next ${secteurChoisi ? 'active' : ''}`} disabled={!secteurChoisi} onClick={() => setEtape(2)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 2 && (
        <div className="wizard-content">
          <Badge />
          <h2>Informations de base</h2>
          <p>Ces informations apparaîtront sur toutes les pages.</p>
          <div className="form-grid">
            <div className="form-group"><label>Nom de votre organisation *</label><input type="text" placeholder="Ex: PEFEP Resto Bar" value={infos.nom} onChange={e => setInfos({ ...infos, nom: e.target.value })} /></div>
            <div className="form-group"><label>Ville ou région *</label><input type="text" placeholder="Ex: Léogâne" value={infos.ville} onChange={e => setInfos({ ...infos, ville: e.target.value })} /></div>
            <div className="form-group full-width"><label>Objectif(s) du site * <span className="optional">(1 à 3)</span></label>
              <div className="choix-groupe">
                {objectifsOptions.map(opt => (
                  <button key={opt} type="button" className={`choix-btn ${objectifs.includes(opt) ? 'selected' : ''}`} onClick={() => toggleObjectif(opt)}>
                    {objectifs.includes(opt) ? '✅ ' : ''}{opt}
                  </button>
                ))}
              </div>
            </div>
            <div className="form-group full-width"><label>Public cible</label><input type="text" placeholder="Ex: Clients locaux" value={publicCible} onChange={e => setPublicCible(e.target.value)} /></div>
            <div className="form-group"><label>Email de contact *</label><input type="email" placeholder="contact@..." value={infos.email} onChange={e => setInfos({ ...infos, email: e.target.value })} /><p className="mots-cles-help">📩 Cet e-mail vous servira aussi à recevoir les commandes, inscriptions et messages laissés sur votre site. Utilisez une adresse que vous consultez régulièrement.</p></div>
            <div className="form-group"><label>WhatsApp <span className="optional">(optionnel)</span></label><input type="text" placeholder="+509..." value={infos.whatsapp} onChange={e => setInfos({ ...infos, whatsapp: e.target.value })} /></div>
            <div className="form-group full-width"><label>Adresse physique <span className="optional">(optionnel)</span></label><input type="text" placeholder="Ex: Léogâne" value={infos.adresse} onChange={e => setInfos({ ...infos, adresse: e.target.value })} /></div>
            <UploadPhotoV5 label="Logo de votre organisation" tag="logo" nomClient={infos.nom} urlUploadee={logoUrl} onUpload={setLogoUrl} />
            <div className="form-group full-width"><label>Réseaux sociaux <span className="optional">(optionnel)</span></label>
              <div className="choix-groupe">
                {reseauxList.map(r => (
                  <button key={r.id} type="button" className={`choix-btn ${reseauxChoisis[r.id] !== undefined ? 'selected' : ''}`} onClick={() => toggleReseau(r.id)}>
                    {reseauxChoisis[r.id] !== undefined ? '✅ ' : ''}{r.label}
                  </button>
                ))}
              </div>
              <div className="reseaux-liens">
                {reseauxList.filter(r => reseauxChoisis[r.id] !== undefined).map(r => (
                  <div key={r.id} className="reseau-lien">
                    <span className="reseau-lien-label">{r.label} :</span>
                    <input type="url" placeholder={r.placeholder} value={reseauxChoisis[r.id] || ''} onChange={e => setReseauxChoisis({ ...reseauxChoisis, [r.id]: e.target.value })} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(1)}>← Retour</button>
            <button type="button" className={`btn-next ${infosCompletes ? 'active' : ''}`} disabled={!infosCompletes} onClick={() => setEtape(3)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 3 && (
        <div className="wizard-content">
          <Badge />
          <h2>🎨 Personnalisez le design</h2>
          <p>Choisissez une palette prédéfinie ou personnalisez.</p>
          <div className="phase-label">🎨 Palettes prédéfinies</div>
          <p className="phase-desc">Cliquez pour appliquer.</p>
          <div className="palettes-grid">
            {palettes_triees().map(p => (
              <PalettePreview key={p.id} palette={p} isActive={paletteChoisie === p.id} onClick={() => appliquerPalette(p)} recommande={secteurChoisi && p.recommandePour.includes(secteurChoisi)} />
            ))}
          </div>
          <div className="phase-label">🎨 Personnalisation</div>
          <div className="couleurs-avancees">
            <SelecteurCouleur label="Couleur principale *" valeur={couleur1} onChange={setCouleur1} ouvert={picker1Ouvert} setOuvert={setPicker1Ouvert} />
            <SelecteurCouleur label="Couleur secondaire *" valeur={couleur2} onChange={setCouleur2} ouvert={picker2Ouvert} setOuvert={setPicker2Ouvert} />
            <SelecteurCouleur label="Couleur d'accent" valeur={couleur3} onChange={setCouleur3} ouvert={picker3Ouvert} setOuvert={setPicker3Ouvert} />
          </div>
          <ApercuTempsReel couleur1={couleur1} couleur2={couleur2} couleur3={couleur3} police={police || 'poppins'} />
          <div className="phase-label">💼 Style *</div>
          <div className="form-group full-width">
            <div className="style-grid">
              {styles_design.map(s => (
                <button key={s.id} type="button" className={`style-card ${styleDesign === s.id ? 'selected' : ''}`} onClick={() => setStyleDesign(s.id)}>
                  <div className="style-label">{s.label}</div>
                  <div className="style-desc">{s.desc}</div>
                </button>
              ))}
            </div>
          </div>
          <div className="phase-label">🔤 Police *</div>
          <div className="polices-grid-v4">
            {polices_triees().map(p => {
              const recommande = secteurChoisi && p.recommandePour.includes(secteurChoisi);
              return (
                <button key={p.id} type="button" className={`police-card-v4 ${police === p.id ? 'selected' : ''}`} onClick={() => setPolice(p.id)}>
                  {recommande && <span className="police-badge">✨ Recommandé</span>}
                  <div className="police-exemple-v4" style={{ fontFamily: `'${p.nom}', sans-serif` }}>Aa</div>
                  <div className="police-nom-v4" style={{ fontFamily: `'${p.nom}', sans-serif` }}>{p.nom}</div>
                  <div className="police-style-v4">{p.style}</div>
                  <div className="police-desc-v4">{p.desc}</div>
                </button>
              );
            })}
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(2)}>← Retour</button>
            <button type="button" className={`btn-next ${designComplet ? 'active' : ''}`} disabled={!designComplet} onClick={() => setEtape(4)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 4 && (
        <div className="wizard-content">
          <Badge />
          <h2>🏠 Votre Page d'Accueil</h2>
          <div className="phase-label">Section Hero</div>
          <div className="form-grid">
            <div className="form-group full-width"><label>En une phrase, que faites-vous ?</label>
              <input type="text" placeholder="Ex: Nous aidons..." value={heroDescription} onChange={e => setHeroDescription(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Résultat principal ?</label>
              <input type="text" placeholder="Ex: Plus de clients..." value={heroResultat} onChange={e => setHeroResultat(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Action principale (CTA)</label>
              <div className="choix-groupe">
                {ctaOptions.map(opt => (
                  <button key={opt} type="button" className={`choix-btn ${heroCta === opt ? 'selected' : ''}`} onClick={() => setHeroCta(opt)}>
                    {heroCta === opt ? '✅ ' : ''}{opt}
                  </button>
                ))}
              </div>
            </div>
            <UploadPhotoV5 label="Photo principale (Hero)" tag="hero" nomClient={infos.nom} urlUploadee={heroPhotoUrl} onUpload={setHeroPhotoUrl} />
          </div>
          <div className="phase-label">Résumé À Propos</div>
          <div className="form-grid">
            <div className="form-group full-width"><label>En 2-3 phrases, qui êtes-vous ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Nous sommes..." value={aproposResume} onChange={e => setAproposResume(e.target.value)} />
            </div>
            <div className="form-group"><label>Année de création</label>
              <input type="text" placeholder="Ex: 2020" value={anneeCreation} onChange={e => setAnneeCreation(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Chiffres clés <span className="optional">(optionnel)</span></label>
              <input type="text" placeholder="Ex: 500 clients..." value={chiffres} onChange={e => setChiffres(e.target.value)} />
            </div>
          </div>
          <div className="phase-label">Témoignages réels de vos clients</div>
          <div className="info-supp">📌 Les témoignages ici seront utilisés TELS QUELS dans votre site.</div>
          {temoignages.map((t, i) => (
            <TemoignageForm key={i} index={i} temoignage={t} onChange={(c, v) => updateTemoignage(i, c, v)} nomClient={infos.nom} />
          ))}
          <button type="button" className="btn-ajouter" onClick={() => setTemoignages([...temoignages, { nom: '', ville: '', texte: '', photo_url: '' }])}>+ Ajouter un témoignage</button>
          <div className="form-grid" style={{ marginTop: 20 }}>
            <div className="form-group full-width"><label>Message d'invitation au contact</label>
              <input type="text" placeholder="Ex: Parlons de votre projet" value={messageInvitation} onChange={e => setMessageInvitation(e.target.value)} />
            </div>
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(3)}>← Retour</button>
            <button type="button" className="btn-next active" onClick={() => setEtape(5)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 5 && (
        <div className="wizard-content">
          <Badge />
          <h2>👥 Votre Page À Propos</h2>
          <div className="phase-label">Histoire et Mission</div>
          <div className="form-grid">
            <div className="form-group full-width"><label>Comment tout a commencé ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Tout a commencé..." value={histoire.debut} onChange={e => setHistoire({ ...histoire, debut: e.target.value })} />
            </div>
            <div className="form-group full-width"><label>Quel défi avez-vous voulu résoudre ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Le principal défi..." value={histoire.defi} onChange={e => setHistoire({ ...histoire, defi: e.target.value })} />
            </div>
            <div className="form-group full-width"><label>Où en êtes-vous aujourd'hui ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Aujourd'hui..." value={histoire.aujourdhui} onChange={e => setHistoire({ ...histoire, aujourdhui: e.target.value })} />
            </div>
            <div className="form-group full-width"><label>Mission en une phrase</label>
              <input type="text" placeholder="Ex: Accompagner..." value={mission} onChange={e => setMission(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Vision 5 ans</label>
              <input type="text" placeholder="Ex: Devenir la référence..." value={vision} onChange={e => setVision(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Vos 3 valeurs</label>
              <input type="text" placeholder="Ex: Intégrité, Excellence..." value={valeurs} onChange={e => setValeurs(e.target.value)} />
            </div>
          </div>
          <div className="phase-label">L'Équipe</div>
          <div className="info-supp">👥 <strong>NOUVEAU v5.2</strong> : Les membres seront affichés sur la page À Propos du site généré !</div>
          <div className="form-grid">
            <div className="form-group full-width"><label>Voulez-vous présenter votre équipe ?</label>
              <div className="choix-groupe">
                {['Oui', 'Non', 'Je suis seul(e)'].map(opt => (
                  <button key={opt} type="button" className={`choix-btn ${equipe === opt ? 'selected' : ''}`} onClick={() => setEquipe(opt)}>
                    {equipe === opt ? '✅ ' : ''}{opt}
                  </button>
                ))}
              </div>
            </div>
          </div>
          {equipe === 'Oui' && (
            <div>
              {membres.map((m, i) => (
                <div key={i} className="service-block">
                  <div className="service-header">Membre #{i + 1}</div>
                  <div className="form-grid">
                    <div className="form-group"><label>Nom complet</label>
                      <input type="text" placeholder="Ex: Jean-Pierre Michel" value={m.nom || ''} onChange={e => updateMembre(i, 'nom', e.target.value)} />
                    </div>
                    <div className="form-group"><label>Poste / Rôle</label>
                      <input type="text" placeholder="Ex: Directeur Général" value={m.poste || ''} onChange={e => updateMembre(i, 'poste', e.target.value)} />
                    </div>
                    <div className="form-group full-width"><label>Description courte</label>
                      <textarea className="form-textarea" rows={2} placeholder="Ex: 10 ans d'expérience..." value={m.description || ''} onChange={e => updateMembre(i, 'description', e.target.value)} />
                    </div>
                    <UploadPhotoV5 label="Photo du membre" tag="membre" nomClient={infos.nom} index={i} urlUploadee={m.photo_url} onUpload={(url) => updateMembre(i, 'photo_url', url)} />
                  </div>
                </div>
              ))}
              <button type="button" className="btn-ajouter" onClick={() => setMembres([...membres, { nom: '', poste: '', description: '', photo_url: '' }])}>+ Ajouter un membre</button>
            </div>
          )}
          <div className="form-grid" style={{ marginTop: 20 }}>
            <div className="form-group full-width"><label>Pourquoi vos clients devraient-ils vous choisir ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Nous sommes les seuls..." value={raisonChoisir} onChange={e => setRaisonChoisir(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Qu'est-ce que vous faites différemment ?</label>
              <textarea className="form-textarea" rows={3} placeholder="Ex: Contrairement..." value={difference} onChange={e => setDifference(e.target.value)} />
            </div>
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(4)}>← Retour</button>
            <button type="button" className="btn-next active" onClick={() => setEtape(6)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 6 && (
        <div className="wizard-content">
          <Badge />
          <EtapeSix secteurChoisi={secteurChoisi} items={items} setItems={setItems} modeGlobalValue={modeGlobalValue} setModeGlobalValue={setModeGlobalValue} typeEcole={typeEcole} setTypeEcole={setTypeEcole} nomClient={infos.nom} />
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(5)}>← Retour</button>
            <button type="button" className={`btn-next ${etape6Complete ? 'active' : ''}`} disabled={!etape6Complete} onClick={() => setEtape(7)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 7 && (
        <div className="wizard-content">
          <Badge />
          <h2>📞 Votre Page Contact</h2>
          <div className="form-grid">
            <div className="form-group full-width"><label>Titre</label>
              <input type="text" placeholder="Ex: Parlons de votre projet" value={titreContact} onChange={e => setTitreContact(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Modes de contact</label>
              <div className="choix-groupe">
                {['Formulaire en ligne', 'WhatsApp', 'Email', 'Téléphone', 'Adresse physique'].map(opt => (
                  <button key={opt} type="button" className={`choix-btn ${modesContact[opt] ? 'selected' : ''}`} onClick={() => toggleModeContact(opt)}>
                    {modesContact[opt] ? '✅ ' : ''}{opt}
                  </button>
                ))}
              </div>
            </div>
            <div className="form-group full-width"><label>Champs du formulaire</label>
              <div className="choix-groupe">
                {['Nom', 'Email', 'Téléphone', 'Message', 'Objet', 'Organisation'].map(champ => (
                  <button key={champ} type="button" className={`choix-btn ${champsForm[champ] ? 'selected' : ''}`} onClick={() => toggleChampForm(champ)}>
                    {champsForm[champ] ? '✅ ' : ''}{champ}
                  </button>
                ))}
              </div>
            </div>
            <div className="form-group full-width"><label>Message de bienvenue</label>
              <input type="text" placeholder="Ex: Nous répondons sous 24h" value={messageBienvenue} onChange={e => setMessageBienvenue(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Adresse Google Maps</label>
              <input type="text" placeholder="Ex: Léogâne" value={googleMaps} onChange={e => setGoogleMaps(e.target.value)} />
            </div>
            <div className="form-group full-width"><label>Horaires</label>
              <input type="text" placeholder="Ex: Lundi-Vendredi 8h-17h" value={horaires} onChange={e => setHoraires(e.target.value)} />
            </div>
          </div>
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(6)}>← Retour</button>
            <button type="button" className="btn-next active" onClick={() => setEtape(8)}>Continuer →</button>
          </div>
        </div>
      )}
      {etape === 8 && (
        <div className="wizard-content">
          <Badge />
          <h2>💳 Finalisation</h2>
          <div className="phase-label">🔑 Mots-clés SEO</div>
          <div className="form-group full-width">
            <label>Mots-clés (séparés par virgules)</label>
            <input type="text" placeholder="Ex: restaurant Léogâne..." value={motsClesSEO} onChange={e => setMotsClesSEO(e.target.value)} />
            <p className="mots-cles-help">💡 Aident Google à trouver votre site.</p>
          </div>
          <div className="phase-label">Moyens de paiement</div>
          <div className="form-group full-width">
            <div className="choix-groupe">
              {moyensPaiement.map(opt => (
                <button key={opt.id} type="button" className={`choix-btn ${moyensDons[opt.id] !== undefined ? 'selected' : ''}`} onClick={() => toggleMoyenDon(opt.id)}>
                  {moyensDons[opt.id] !== undefined ? '✅ ' : ''}{opt.label}
                </button>
              ))}
            </div>
            <div className="reseaux-liens">
              {moyensPaiement.filter(opt => moyensDons[opt.id] !== undefined && !opt.virementDetaille).map(opt => (
                <div key={opt.id} className="reseau-lien">
                  <span className="reseau-lien-label">{opt.champ} :</span>
                  <input type="text" placeholder={opt.placeholder} value={moyensDons[opt.id] || ''} onChange={e => setMoyensDons({ ...moyensDons, [opt.id]: e.target.value })} />
                </div>
              ))}
            </div>
            {moyensDons.virement_bancaire !== undefined && <VirementBancaireForm virement={virementBancaire} setVirement={setVirementBancaire} />}
          </div>
          <div className="phase-label">Questions spécifiques — {secteurLabel}</div>
          <QuestionsSecteur secteurId={secteurChoisi} reponses={reponsesSecteur} onChange={(id, val) => setReponsesSecteur({ ...reponsesSecteur, [id]: val })} />
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(7)}>← Retour</button>
            <button type="button" className="btn-generer" onClick={() => setEtape(9)}>Voir récapitulatif →</button>
          </div>
        </div>
      )}
      {etape === 9 && (
        <div className="wizard-content">
          <Badge />
          <h2>🎉 Récapitulatif</h2>
          <div className="recap-box">
            <div className="recap-section-title">Informations générales</div>
            <div className="recap-item"><span className="recap-label">Type</span><span className="recap-value">{secteurLabel}</span></div>
            <div className="recap-item"><span className="recap-label">Organisation</span><span className="recap-value">{infos.nom}</span></div>
            <div className="recap-item"><span className="recap-label">Ville</span><span className="recap-value">{infos.ville}</span></div>
            <div className="recap-item"><span className="recap-label">Email</span><span className="recap-value">{infos.email}</span></div>
            <div className="recap-section-title">Photos uploadées</div>
            <div className="recap-item"><span className="recap-label">Logo</span><span className="recap-value">{logoUrl ? '✅ Uploadé' : '—'}</span></div>
            <div className="recap-item"><span className="recap-label">Photo Hero</span><span className="recap-value">{heroPhotoUrl ? '✅ Uploadé' : '—'}</span></div>
            <div className="recap-item"><span className="recap-label">Photos items</span><span className="recap-value">{items.filter(i => i.photo).length} / {items.length}</span></div>
            <div className="recap-item"><span className="recap-label">Photos témoignages</span><span className="recap-value">{temoignages.filter(t => t.photo_url).length} / {temoignages.length}</span></div>
            <div className="recap-item"><span className="recap-label">Photos membres</span><span className="recap-value">{membres.filter(m => m.photo_url).length} / {membres.filter(m => m.nom).length}</span></div>
            <div className="recap-section-title">Contenu</div>
            <div className="recap-item"><span className="recap-label">{configEtape6?.titre || 'Éléments'}</span><span className="recap-value">{items.length} {configEtape6?.labelItem}</span></div>
            <div className="recap-item"><span className="recap-label">Témoignages réels</span><span className="recap-value">{temoignages.filter(t => t.nom && t.texte).length} valides</span></div>
            <div className="recap-item"><span className="recap-label">Équipe</span><span className="recap-value">{equipe || 'Non précisé'}</span></div>
            {equipe === 'Oui' && (
              <div className="recap-item"><span className="recap-label">Membres</span><span className="recap-value">{membres.filter(m => m.nom).length} membre(s)</span></div>
            )}
            {modeGlobalValue && <div className="recap-item"><span className="recap-label">Mode de service</span><span className="recap-value">{modeGlobalValue}</span></div>}
            <div className="recap-item"><span className="recap-label">Réseaux sociaux</span><span className="recap-value">{Object.keys(reseauxChoisis).filter(k => reseauxChoisis[k]).length} réseaux</span></div>
            <div className="recap-section-title">Design</div>
            <div className="recap-item"><span className="recap-label">Style</span><span className="recap-value">{styleDesign}</span></div>
            <div className="recap-item"><span className="recap-label">Police</span><span className="recap-value">{polices.find(p => p.id === police)?.nom || police}</span></div>
            <div className="recap-item"><span className="recap-label">Couleurs</span>
              <span className="recap-value" style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end' }}>
                <span style={{ display: 'inline-block', width: 22, height: 22, borderRadius: 4, background: couleur1, border: '1px solid #ddd' }}></span>
                <span style={{ display: 'inline-block', width: 22, height: 22, borderRadius: 4, background: couleur2, border: '1px solid #ddd' }}></span>
                <span style={{ display: 'inline-block', width: 22, height: 22, borderRadius: 4, background: couleur3, border: '1px solid #ddd' }}></span>
              </span>
            </div>
          </div>
          {erreurGeneration && <div style={{ background: '#FFF0F0', border: '1px solid red', padding: 16, borderRadius: 10, marginBottom: 20, color: 'red' }}>⚠️ {erreurGeneration}</div>}
          <div className="wizard-actions">
            <button type="button" className="btn-back" onClick={() => setEtape(8)}>← Retour</button>
            <button type="button" className="btn-generer" onClick={genererSite} disabled={generationEnCours}>
              {generationEnCours ? '⏳ Génération en cours...' : '🚀 Générer mon site avec l\'IA'}
            </button>
          </div>
        </div>
      )}
      {etape === 10 && (
       <PreviewSite contenu={siteGenere} apercuHtml={apercuHtml} infos={infos} design={{ couleur1, couleur2, couleur3, style: styleDesign, police }} logoUrl={logoUrl} heroPhotoUrl={heroPhotoUrl} onRetour={() => setEtape(9)} siteId={siteIdEnBase} statut="brouillon" />
      )}
      {etape === 10 && (
        <section className="wizard-domaine">
          <div className="wizard-domaine-entete">
            <div className="wizard-domaine-etiquette">Dernière étape</div>
            <h2>Votre site mérite sa propre adresse</h2>
            <p>
              Votre site est prêt. Une adresse à votre nom inspire confiance et
              vous rend trouvable sur Google. Nous avons vérifié la disponibilité
              pour vous.
            </p>
          </div>

          <RechercheDomaine
            valeurInitiale={infos.nom}
            titre="Disponibilité de votre adresse"
            sousTitre="Nous avons cherché à partir du nom de votre organisation. Modifiez-le si vous préférez autre chose."
          />

          <div className="wizard-domaine-note">
            Vous pouvez aussi garder votre sous-domaine PEFEP gratuit et ajouter
            un nom de domaine plus tard, depuis votre tableau de bord.
          </div>
        </section>
      )}

    </div>
  );
}

export default PageClient;